(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44],{

/***/ 13932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ A; },
  "E": function() { return /* binding */ Code; },
  "H1": function() { return /* binding */ H1; },
  "H2": function() { return /* binding */ H2; },
  "H3": function() { return /* binding */ H3; },
  "H4": function() { return /* binding */ H4; },
  "H5": function() { return /* binding */ H5; },
  "H6": function() { return /* binding */ H6; },
  "HR": function() { return /* binding */ HR; },
  "LI": function() { return /* binding */ LI; },
  "OL": function() { return /* binding */ OL; },
  "P": function() { return /* binding */ P; },
  "UL": function() { return /* binding */ UL; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(40639);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/esm/prism.js + 15 modules
var prism = __webpack_require__(22557);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/cjs/styles/prism/index.js
var styles_prism = __webpack_require__(84283);
;// CONCATENATED MODULE: ./lib/shared/utils.ts
/**
 * Adapted from the markdown-toc utility, to parallel its functionality.
 *
 * @param string
 * @returns
 */
function slugify(string) {
  var str = string;
  str = str.toLowerCase();
  str = str.split(' ').join('-');
  str = str.split(/\t/).join('--');
  str = str.split(/<\/?[^>]+>/).join(''); // eslint-disable-next-line no-useless-escape

  str = str.split(/[|$&`~=\\\/@+*!?({[\]})<>=.,;:'"^]/).join('');
  str = str.split(/[。？！，、；：“”【】（）〔〕［］﹃﹄“ ”‘’﹁﹂—…－～《》〈〉「」]/).join('');
  return str;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./lib/shared/contentRenderers.tsx

var _excluded = ["children"];






var P = function P(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
    as: "p",
    mb: 4,
    children: children
  });
};
var H1 = function H1(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h1",
    size: "2xl",
    mb: 5,
    id: slugify(children.toString()),
    children: children
  });
};
var H2 = function H2(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h2",
    size: "xl",
    mb: 3,
    id: slugify(children.toString()),
    children: children
  });
};
var H3 = function H3(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h3",
    size: "lg",
    mb: 3,
    id: slugify(children.toString()),
    children: children
  });
};
var H4 = function H4(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h4",
    size: "md",
    mb: 3,
    id: slugify(children.toString()),
    children: children
  });
};
var H5 = function H5(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h5",
    size: "sm",
    mb: 3,
    id: slugify(children.toString()),
    children: children
  });
};
var H6 = function H6(_ref7) {
  var children = _ref7.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    as: "h6",
    size: "xs",
    mb: 1,
    id: slugify(children.toString()),
    children: children
  });
};
var HR = function HR() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    mb: 4,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {})
  });
};
var Code = function Code(_ref8) {
  var _rest$className;

  var children = _ref8.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref8, _excluded);

  var language = ((_rest$className = rest.className) === null || _rest$className === void 0 ? void 0 : _rest$className.replace(/language-/, '')) || 'javascript';

  if (!rest.inline) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
      mb: 4,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prism/* default */.Z, {
        language: language,
        style: styles_prism/* okaidia */.be,
        children: children
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
    as: "code",
    color: "brand.red",
    children: children
  });
};
var OL = function OL(_ref9) {
  var children = _ref9.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* OrderedList */.GS, {
    mb: 3,
    children: children
  });
};
var UL = function UL(_ref10) {
  var children = _ref10.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* UnorderedList */.QI, {
    mb: 3,
    children: children
  });
};
var LI = function LI(_ref11) {
  var children = _ref11.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* ListItem */.HC, {
    children: children
  });
};
var A = function A(_ref12) {
  var children = _ref12.children,
      href = _ref12.href;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: href,
    passHref: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Link */.rU, {
      textDecoration: "underline",
      children: children
    })
  });
}; // export const IMG = ({
//   src,
//   alt,
//   width,
//   height,
//   ...rest
// }: JSX.IntrinsicElements['img']) => {
//   return (
//     <Container position="relative">
//       <Image
//         src={src}
//         alt={alt}
//         layout="responsive"
//         width={width}
//         height={height}
//         {...rest}
//       />
//     </Container>
//   );
// };

/***/ }),

/***/ 48791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Section": function() { return /* binding */ Section; },
/* harmony export */   "default": function() { return /* binding */ StyleGuidePage; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40639);
/* harmony import */ var layouts_SiteOuterLayout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61607);
/* harmony import */ var lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13932);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Section = function Section(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
    maxW: "container.xl",
    mb: 5,
    padding: 10,
    borderRadius: 20,
    backgroundColor: "gray.100",
    children: children
  });
};
function StyleGuidePage() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.H1, {
      children: "CITJS StyleGuide"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .iz, {
      mb: 5,
      mt: 5
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Section, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.H1, {
        children: "H1: The quick brown fox jumped over the lazy dogs."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.H2, {
        children: "H2: The quick brown fox jumped over the lazy dogs."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.H3, {
        children: "H3: The quick brown fox jumped over the lazy dogs."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.H4, {
        children: "H4: The quick brown fox jumped over the lazy dogs."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.H5, {
        children: "H5: The quick brown fox jumped over the lazy dogs."
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.H6, {
        children: "H6: The quick brown fox jumped over the lazy dogs."
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Section, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.UL, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Unordered list item 1"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Unordered list item 2"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Unordered list item 3"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Unordered list item 4"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Unordered list item 5"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.OL, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Ordered list item 1"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Ordered list item 2"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Ordered list item 3"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Ordered list item 4"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lib_shared_contentRenderers__WEBPACK_IMPORTED_MODULE_1__.LI, {
          children: "Ordered list item 5"
        })]
      })]
    })]
  });
}

StyleGuidePage.getLayout = function (page) {
  return (0,layouts_SiteOuterLayout__WEBPACK_IMPORTED_MODULE_0__/* .getLayout */ .G0)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
    maxW: "container.xl",
    children: page
  }));
};

/***/ }),

/***/ 50980:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/styleguide",
      function () {
        return __webpack_require__(48791);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [503,774,888,179], function() { return __webpack_exec__(50980); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);